import React, { useEffect, useRef, useState } from 'react';
import { addDoc, collection, doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import EmojiPicker from 'emoji-picker-react';
import { db } from '../../services/firebaseConfig';
import hugeicons_sent from "../../images/hugeicons_sent.png";

export const SendMessage = ({ conversationId, recipientId, profile }) => {
  const [input, setInput] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
  const username = localStorage.getItem('username');

  const onEmojiClick = ( emojiObject) => {
    if (emojiObject) {
      setInput((prev) => prev + emojiObject.emoji);
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const messageData = {
      message: input,
      senderId: username,
      timestamp: serverTimestamp(),
      status: 'sent',
    };

    setInput('');

    // Firestore logic
    const userRef = doc(db, 'users', username);
    const userDoc = await getDoc(userRef);
    if (!userDoc.exists()) {
      await setDoc(userRef, {
        username,
        name: localStorage.getItem('user_name'),
        profilePic: localStorage.getItem('profilePic'),
        lastSeen: serverTimestamp(),
      });
    } else {
      await updateDoc(userRef, { lastSeen: serverTimestamp() });
    }

    const recipientRef = doc(db, 'users', recipientId);
    const recipientDoc = await getDoc(recipientRef);
    if (!recipientDoc.exists()) {
      await setDoc(recipientRef, {
        username: recipientId,
        name: profile.name,
        profilePic: profile.photo,
        lastSeen: null,
      });
    }

    await addDoc(collection(db, 'conversations', conversationId, 'messages'), messageData);

    const conversationRef = doc(db, 'conversations', conversationId);
    const conversationDoc = await getDoc(conversationRef);
    if (conversationDoc.exists()) {
      await updateDoc(conversationRef, {
        lastMessage: {
          message: input,
          status: "sent",
          senderId: username,
          timestamp: serverTimestamp(),
        },
      });
    } else {
      await setDoc(conversationRef, {
        participants: [username, recipientId],
        lastMessage: {
          message: input,
          timestamp: serverTimestamp(),
        },
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div style={{ position: 'relative' }}>
      <form onSubmit={sendMessage} style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className='send-button'
          onClick={() => setShowEmojiPicker((prev) => !prev)}
          style={{ marginRight: '10px', cursor: 'pointer' }}
        >
          😊
        </button>

        <input
          className="form-control form-control-lg"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type a message"
          style={{ flex: 1 }}
        />

        <button type="submit" className='send-button'>
          <img src={hugeicons_sent} alt="send" />
        </button>
      </form>

      {showEmojiPicker && (
        <div
        ref={emojiPickerRef}
          style={{
            position: 'absolute',
            bottom: '50px',
            left: '10px',
            zIndex: 1000,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}
        >
          <div>
          <EmojiPicker onEmojiClick={onEmojiClick} />
          </div>
        </div>
      )}
    </div>
  );
};
